import { defineFormKitConfig, createInput } from '@formkit/vue'
import FormKitCheckbox from './components/form/FormKitCheckbox.vue'
import FormKitImageUpload from './components/form/FormKitImageUpload.vue'
import FormKitPhoneInput from '~/components/form/FormKitPhoneInput.vue'
import FormKitDropdownInput from '~/components/form/FormKitDropdownInput.vue'
import FormKitDocInput from '~/components/form/FormKitDocInput.vue'
import FormKitTipTap from '~/components/form/FormKitTipTap.vue'

export const TLPhoneInput = createInput(FormKitPhoneInput, {
  // the props here should sync with the type definition in formkit-custom.d.ts
  props: ['enterKeyUpHandler', 'defaultCountry']
})

export const TLDropdownInput = createInput(FormKitDropdownInput, {
  // the props here should sync with the type definition in formkit-custom.d.ts
  props: [
    'placeholder',
    'disabled',
    'itemOptions',
    'multiple',
    'value',
    'values',
    'valuesTitle',
    'searchBox',
    'bottom',
    'limit',
    'addCustom'
  ]
})

export const TLCheckbox = createInput(FormKitCheckbox, {
  props: ['name', 'checked', 'text']
})

export const TLImageInput = createInput(FormKitImageUpload, {
  props: ['value']
})

export const TLDocInput = createInput(FormKitDocInput, {
  // the props here should sync with the type definition in formkit-custom.d.ts
  props: ['accept', 'disabled', 'value', 'disabled']
})

export const TLTipTapInput = createInput(FormKitTipTap, {
  props: [
    'value',
    // 'plain',
    'bold',
    'italic',
    'underline',
    'paragraph',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'bulletlist',
    'orderedlist',
    'codeblock',
    'undo',
    'redo'
  ]
})

function tlPhoneRule(node: any) {
  // @ts-ignore
  if (!node.value || (node.value && !node.value.value)) return true // handle empty value
  const isValid = Boolean(
    // @ts-ignore
    node.value && node.value.isValid
  )
  // if (!isValid) console.log('Phone is invalid', node.value, node.value.isValid)
  return isValid
}

function requiredPhoneRule(node: any) {
  // @ts-ignore
  if (!node.value || (node.value && !node.value.value)) {
    console.log('Phone is required', node.value, node.value.value)
    return false
  }
  return true
}

// const TLImageInput = createInput(FormKitImageInput, {
//   // the props here should sync with the type definition in formkit-custom.d.ts
//   props: ['multiple', 'accept', 'uploadText', 'modalWidth', 'cropperOptions', 'previewOptions']
// })

export default defineFormKitConfig({
  rules: {
    tlPhone: tlPhoneRule,
    requiredPhone: requiredPhoneRule
  },
  // locales: {},
  // etc.
  inputs: {
    tlPhone: TLPhoneInput,
    tlDropdown: TLDropdownInput,
    tlDoc: TLDocInput,
    tlCheckbox: TLCheckbox,
    tlImage: TLImageInput,
    tlTipTap: TLTipTapInput
  }
})
